__turbopack_context__.v({
  "attribution": "cyber-certifications-module__dk8iTG__attribution",
  "card": "cyber-certifications-module__dk8iTG__card",
  "certifications": "cyber-certifications-module__dk8iTG__certifications",
  "compact": "cyber-certifications-module__dk8iTG__compact",
  "dates": "cyber-certifications-module__dk8iTG__dates",
  "detail": "cyber-certifications-module__dk8iTG__detail",
  "grid": "cyber-certifications-module__dk8iTG__grid",
  "image": "cyber-certifications-module__dk8iTG__image",
  "intro": "cyber-certifications-module__dk8iTG__intro",
  "label": "cyber-certifications-module__dk8iTG__label",
  "mark": "cyber-certifications-module__dk8iTG__mark",
  "name": "cyber-certifications-module__dk8iTG__name",
  "status": "cyber-certifications-module__dk8iTG__status",
  "verify": "cyber-certifications-module__dk8iTG__verify",
});
